import request from '@/utils/request'

/**
 * 获取告警列表
 * @param {Object} data - 请求参数
 */
export function getAssetOverview(data) {
  return request({
    url: '/dashboard/v3/ops/daily/many/queryAssetOverview',
    method: 'get',
    params: data
  })
}

/**
 * 获取收益分析列表
 * @param {Object} data - 请求参数
 */
export function getRevenueAnalysis(data) {
  return request({
    url: '/dashboard/v3/ops/daily/many/queryListIncome',
    method: 'get',
    params: data
  })
}

/**
 * 获取容量衰减分析列表
 * @param {Object} data - 请求参数
 */
export function getCapacityDecayAnalysis(data) {
  return request({
    url: '/dashboard/v3/ops/daily/many/queryAttenuationCapacity',
    method: 'get',
    params: data
  })
}

/**
 * 获取告警分析列表
 * @param {Object} data - 请求参数
 */
export function getAlarmAnalysis(data) {
  return request({
    url: '/dashboard/v3/ops/daily/many/queryAlarmAnalysis',
    method: 'get',
    params: data
  })
}

/**
 * 获取告警列表
 * @param {Object} data - 请求参数
 */
export function getAlarmList(data) {
  return request({
    url: '/dashboard/v3/ops/daily/many/queryAlarmList',
    method: 'get',
    params: data
  })
}